import React from 'react';
import { Box, Icon } from '@chakra-ui/react';
import { 
  Database, 
  FolderOpen, 
  Globe, 
  Key, 
  LayoutGrid, 
  Lock, 
  Server, 
  Shield, 
  Users, 
  Cloud,
  Layers,
  HardDrive
} from 'lucide-react';

interface ResourceIconProps {
  resourceType: string;
  size?: number;
}

const ResourceIcon: React.FC<ResourceIconProps> = ({ resourceType, size = 5 }) => {
  const getIconForType = () => {
    switch (resourceType) {
      case 'app':
        return Globe;
      case 'group':
        return Users;
      case 'permission_set':
        return Shield;
      case 'role':
        return Key;
      case 'identity_store':
        return Lock;
      case 'database':
        return Database;
      case 'server':
        return Server;
      case 'drive':
        return HardDrive;
      case 'repository':
        return FolderOpen;
      case 'aws_account':
        return Cloud;
      case 'policy':
        return Shield;
      default:
        return LayoutGrid;
    }
  };

  const getColorForType = () => {
    switch (resourceType) {
      case 'app':
        return 'blue.500';
      case 'group':
        return 'green.500';
      case 'permission_set':
        return 'purple.500';
      case 'role':
        return 'orange.500';
      case 'identity_store':
        return 'red.500';
      case 'database':
        return 'cyan.500';
      case 'server':
        return 'gray.600';
      case 'drive':
        return 'yellow.500';
      case 'repository':
        return 'teal.500';
      case 'aws_account':
        return 'orange.500';
      case 'policy':
        return 'purple.500';
      default:
        return 'gray.500';
    }
  };

  return (
    <Box
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg={`${getColorForType()}15`}
      borderRadius="md"
      p={1.5}
    >
      <Icon as={getIconForType()} boxSize={size} color={getColorForType()} />
    </Box>
  );
};

export default ResourceIcon;